import { generateContext } from '../../utils'
export interface SearchConfigContextType {}
const [SearchConfigContext, SearchConfigProvider] = generateContext<SearchConfigContextType>()
export { SearchConfigContext, SearchConfigProvider }
